/**
 * P2-05 · <HomeSection> — the shared block wrapper (template:core).
 *
 * Owns the page's vertical rhythm, max-width, and the optional per-block
 * background token; blocks never set their own page margins (P2-DB01 §02).
 * Every block is a <section> with an accessible name — pass `label` when the
 * block has no visible heading.
 */
import { cn } from "~/lib/utils";
import type { BlockBackground } from "~/server/content/registry";

const BACKGROUNDS: Record<BlockBackground, string> = {
  default: "bg-bg text-fg",
  subtle: "bg-surface-2 text-fg",
  primary: "bg-primary text-primary-fg",
  dark: "bg-fg text-bg",
};

export function HomeSection({
  background = "default",
  label,
  children,
}: {
  background?: BlockBackground;
  label?: string;
  children: React.ReactNode;
}) {
  return (
    <section
      aria-label={label}
      className={cn("w-full", BACKGROUNDS[background])}
    >
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-14">
        {children}
      </div>
    </section>
  );
}
